import { forwardRef, createElement } from 'react';

function IconArrowRight(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M13.946 7.897l.084.073 3.5 3.5.036.038.044.056.051.081.05.116.027.103.01.084v.103l-.018.12-.039.12-.038.078-.06.09-.063.071-3.5 3.5a.75.75 0 01-1.133-.976l.073-.084 2.218-2.22H7a.75.75 0 01-.102-1.493L7 11.25h8.189l-2.22-2.22a.75.75 0 01.977-1.133z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ArrowRight = /*#__PURE__*/forwardRef(IconArrowRight);

export default ArrowRight;
//# sourceMappingURL=ArrowRight.js.map
